export const getPageQueryParams = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return Object.fromEntries(urlSearchParams.entries());
};

export const getPageURLWithoutQueryParams =
  () => `${window.location.protocol}//${window.location.hostname}${window.location.pathname}`;

export const getPageQueryParam = (param) => (
  new URL(document.location).searchParams.get(param)
);

export const replaceUrlParam = (url, paramName, paramValue) => {
  const [base, queryString = ''] = url.split('?');
  const params = new URLSearchParams(queryString);
  params.set(paramName, paramValue);

  return `${base}?${params.toString()}`;
};

export const generateUrl = (baseUrl, params) => {
  const urlParams = new URLSearchParams(params);

  return `${baseUrl}?${urlParams.toString()}`;
};
